/**
 * Vaste site-header (Guapaa-branding) voor publieke pagina’s zoals salonzoeken en inloggen.
 */

import { Link } from 'react-router-dom'

export type SaloniPublicHeaderProps = {
  /** Doel-URL voor de rechter-CTA */
  navHref?: string
  navLabel?: string
}

export function SaloniPublicHeader ({
  navHref = '/login?entry=keuze',
  navLabel = 'Mijn salon'
}: SaloniPublicHeaderProps) {
  return (
    <header className="fixed left-0 right-0 top-0 z-50 border-b border-border/80 bg-background/95 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4 sm:px-6">
        <Link
          to="/salon"
          className="text-xl font-bold tracking-tight text-foreground"
        >
          Guap<span className="text-primary">aa</span>
        </Link>
        <nav className="flex items-center gap-4 sm:gap-6" aria-label="Snelkoppelingen">
          <Link
            to={navHref}
            className="btn-outline-primary rounded-full px-4 py-2 text-sm"
          >
            {navLabel}
          </Link>
        </nav>
      </div>
    </header>
  )
}
